export default [
    {
        path: 'impressoes',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-impressoes' */
            '@/views/exame-laboratorial/impressoes/Index'
        ),
        redirect: 'impressoes/create',
        children: [
            {
                name: 'exame-laboratorial-impressoes-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-impressoes' */
                    '@/views/exame-laboratorial/impressoes/Form.vue'
                ),
            },
        ],
    }
]